import '@babel/polyfill'
import 'nodelist-foreach-polyfill'

export default () => {
  const headings = document.querySelectorAll('[data-footer-heading]')
  if (!headings) {
    return
  }

  headings.forEach(heading => {
    heading.addEventListener('click', () => {
      heading.parentElement.classList.toggle('-active')
    })
  })
}
